import reduce from 'lodash/reduce'
import { replaceEntities, mergeEntities, getEntity } from '@fakundo/redux-entities'
import { PROPOSALS } from 'constants/entityNames'

export const fetchProposals = () => (
  (dispatch, getState, api) => api({
    apiPath: 'proposals',
  })
)

export const createProposal = (proposalData, cancelToken) => (
  async (dispatch, getState, api) => {
    const proposal = await api({
      method: 'post',
      apiPath: 'proposals',
      data: { ...proposalData, order: 0 },
      cancelToken
    })
    dispatch(replaceEntities(PROPOSALS, { [proposal.uuid]: proposal }))
    return proposal
  }
)

export const patchProposalLazy = (uuid, data, cancelToken) => (
  async (dispatch, getState, api) => {
    const prevProposal = getEntity(getState(), PROPOSALS, uuid)
    dispatch(replaceEntities(PROPOSALS, { [uuid]: { ...prevProposal, ...data } }))
    await api({
      method: 'patch',
      apiPath: `proposals/${uuid}`,
      data,
      cancelToken
    })
  }
)

export const deleteProposalLazy = (uuid, cancelToken) => (
  patchProposalLazy(uuid, { deleted: true }, cancelToken)
)

export const sortProposalsLazy = (newOrderedProposalsUuids, cancelToken) => (
  async (dispatch, getState, api) => {
    const nextProposalsData = reduce(newOrderedProposalsUuids, (acc, uuid, index) => {
      return { ...acc, [uuid]: { order: index } }
    }, {})
    dispatch(mergeEntities(PROPOSALS, nextProposalsData))
    await Promise.all(newOrderedProposalsUuids.map(uuid => (
      api({
        method: 'patch',
        apiPath: `proposals/${uuid}`,
        data: nextProposalsData[uuid],
        cancelToken
      })
    )))
  }
)
